import {
  Injectable,
  Output,
  EventEmitter,
  IterableDiffers,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { Filter } from '../core/models/filter';
import { FilterMetadata } from 'primeng/api';
import { param } from 'jquery';
// import { format } from 'date-fns-tz';

@Injectable()
export class Globals {
  @Output() fire: EventEmitter<any> = new EventEmitter();
  public static skeletonArray = Array(10).fill(0); // number of column's of skeleton.
  public static skeletonRows = Array(15).fill(0); // number of rows's of skeleton.
  public static sanitizeSQL: any = new RegExp(
    /\b(SELECT * FROM|UPDATE * FROM|DELETE * FROM|insert|drop|union|alter|xp_|exec|sleep|benchmark|where\s+in|not\s+in|insert_batch|update_batch|LEFT\s+JOIN|RIGHT\s+JOIN|INNER\s+JOIN|JOIN|GROUP\s+BY|SET|ORDER\s+BY|ASC)\b/gi
  );
  // public static sanitizeSQL: any = /\b(SELECT * FROM|insert|drop|union|alter|xp_|exec|sleep|benchmark|where in|not in|insert_batch|update_batch|LEFT JOIN|RIGHT JOIN|INNER JOIN|JOIN|GROUP BY|SET|ORDER BY|ASC)\b/gi;
  public static sanitizeHTML: any = /<\/?[^>]+(>|$)/g;
  public virtualScrollItemSize: number = 40; // Default item size for virtual scroll in PrimeNG tables and enable virtual scroll for large datasets
  public numericColumns: string[] = [
    'lastFuelLevel',
    'dispenseLtr',
    'DFD_DFD_FUE_SALE_LTR',
    'DFD_DFD_FLT_CALCULATED_AVERAGE',
    'DFD_DFD_FUE_HMR_KMR_CURRENT',
    'DFD_DFD_FUE_HMR_KMR_PREVIOUS',
    'DFD_DFD_FUE_IBTN',
    'CWM_CWM_CODE',
    'currentFuelValue',
    'distance',
    'offset',
    'waterOffset',
    'uIdName',
    'uid',
    'fleetCapacity',
    'totalNozzles',
    'simNo',
    'FLTM_FLT_OEM_VALUE',
    'FLTM_FLT_TARGET_VALUE',
    'calculatedFuelQty',
    'TNK_TNK_CAPACITY',
    'FMO_FMO_CODE',
    'FLTM_FLT_NEW_TARGET_VALUE',
    'TAG_TAG_NUMBER',
    'DFD_DFD_TXN_ID',
    'Difference',
    'oemValue',
    'DFD_DFD_EMP_CODE',
    'stockLevel',
    'fuelDispensed',
    'transactions',
    'costCenterCode',
    'servedFleets',
    'thisWeek',
    'thisMonth',
    'lastMonth',
    'currentStock',
    'difference',
    'totalDispensed',
    'openingStock',
    'closingStock',
    'customerNo',
    'USM_USM_MOBILENO',
    'USM_USM_MOBILE1',
    'USM_USM_MOBILE2',
    'tag',
    'tagNumber',
    'oemConsumption',
    'siteConsumption',
    'currentAvgConsumption',
    'lastMeterReading',
    'tankCapacity',
    'targetValue',
    'newTargetValue',
    'costAccount',
    'EMP_EMP_PHONE',
    'EMP_EMP_COSTACCOUNT_FULLCOSTACCOUNT',
    'EMP_EMP_CODE',
    'tagTypeMaster',
    'customerNumber',
    'clientNo',
    'PRL_PRL_YEAR',
    'cc2',
    'PRL_PRL_MONTH',
    'PRL_PRL_TOTAL_VALUE',
    'PRL_PRL_DIESEL_PRICE',
    'PRL_PRL_HANDLING_PRICE',
    'toCostAccount',
    'fromCostAccount',
    'duId',
    'otp',
    'capacity',
    'DRL_DRL_READING',
    'logResponseCode',
    'FUR_FUR_FUEL_QTY',
    'ycsAtgSensor',
    'tosAtgSensor',
    'csAtgSensor',
    'avgConsuption',
    'tcsAtgSensor',
    'ycsDipReading',
    'tcsDipReading',
    'tosDipReading',
    'ALD_ALD_RANDOM_CODE1',
    'ALD_ALD_TAG_NUMBER',
    'ALD_ALD_TOTALIZER',
    'ALD_ALD_ISSUED_QUANTITY',
    'ALD_ALD_PRESET_QUANTITY',
    'saleLtr',
    'dieselPrice',
    'UNIT_PRICE',
    'INCOMING_WEIGHT',
    'DIP_VALUE_BEFORE',
    'OUTGOING_QTY',
    'COST_ACCOUNT_CODE',
    'GROSS_QTY',
    'DENSITY',
    'VENDOR_QTY',
    'ACCEPTED_QTY',
    'OUTSORTED_QTY',
    'cardPhoneNo',
    'serialNo',
    'ipAddress',
    'DC_DEC_SALE_LTR',
    'DC_DEC_TOTALIZER',
    'DC_DEC_BATTERY_VOLTAGE',
    'DC_DEC_TANKER_NUMBER',
    'DC_DEC_COMPARTMENT_SIZE',
    'DC_DEC_COMPARTMENT_NUMBER',
    'DC_DEC_UNLOAD_TANK',
    'DC_DEC_CALIBRATION_RATE',
    'DC_DEC_UNIQUE_IDENTIFIER',
    'phonePin',
    'tagsrNumber',
    'pin1',
    'pin2',
    'puk1',
    'puk2',
    'imei',
    'DVM_DVM_UID',
    'fuelIbtn',
    'fuelSaleLtr',
    'nozzle',
    'totalizer',
    'totalizerSale',
    'hmrKmr',
    'app1',
    'app2',
    'currentCalibrationRate',
    'rfid',
    'netSale',
    'totalLiter',
    'calculatedQty',
    'additionalQty',
    'standardAverage',
    'isSync',
    'transactionId',
    'fuelUid',
  ];
  constructor(private router: Router) { }

  calcVisibleRows(scrollHeight = 580, rowHeight = 40): number {
    return Math.floor(scrollHeight / rowHeight);
  }

  getUser() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    return user;
  }

  getUserId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = user.user_info?.userId;
    return res;
  }

  getCompanyId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = atob(user.user_info?.companyId);
    return res;
  }

  getFavSiteId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = atob(user.user_info?.favouriteSiteId);
    return res;
  }

  getAreaId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = atob(user.user_info?.areaId);
    return res;
  }

  getSiteId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = atob(user.user_info?.siteId);
    return res;
  }
  getRegionId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = atob(user.user_info?.regionId);
    return res;
  }

  getUserInfo() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res: any = {};
    res.defaultPage = atob(user?.user_info?.defaultPage);
    res.email = atob(user.user_info?.email);
    res.firstName = atob(user.user_info?.firstName);
    res.lastName = atob(user.user_info?.lastName);
    res.roleName = atob(user.user_info?.roleName);
    res.userName = atob(user.user_info?.userName);
    res.roleId = atob(user.user_info?.roleId);
    return res;
  }

  getToken() {
    let token: any = localStorage.getItem('Auth_token');
    return token;
  }

  // remove unwanted keys from object and return new object
  filterOutUnwantedKeys(filter: Filter, keysToExclude: string[]): Filter {
    const payload: any = { ...filter }; // Create a copy of the filter object
    keysToExclude.forEach((key) => delete payload[key]); // Delete unwanted keys
    return payload;
  }

  /*
   * @category WEBSITE
   * @author Original Author <dbhavsar@moba.de>
   * @copyright MOBA
   * @comment Only get the wanted keys from the object and return new object
   * @date 2025-10-12
   */
  filteredWantedKeys<T extends Record<string, any>>(
    obj: T,
    wantedKeys: string[]
  ): Record<string, any> {
    const payload: Record<string, any> = {};

    for (const key of wantedKeys) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        payload[key] = obj[key];
      }
    }

    return payload;
  }

  // convertUTCToUserLocalTime(date: Date, format: string = ''): string {
  //   var localTime = moment.utc(date).toDate();

  //   // Create a new Date object with the UTC date's milliseconds
  //   const utcDate = new Date(localTime);

  //   // Get the dynamic time zone code of the user's browser
  //   const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   // Get the dynamic locale from the user's browser
  //   const userLocale = navigator.language;

  //   // Format the date as YYYY-MM-DD HH:mm:ss
  //   const year = utcDate.getFullYear();
  //   const month =
  //     (utcDate.getMonth() + 1 < 10 ? '0' : '') + (utcDate.getMonth() + 1);
  //   const day = (utcDate.getDate() < 10 ? '0' : '') + utcDate.getDate();
  //   const hours = (utcDate.getHours() < 10 ? '0' : '') + utcDate.getHours();
  //   const minutes =
  //     (utcDate.getMinutes() < 10 ? '0' : '') + utcDate.getMinutes();
  //   const seconds =
  //     (utcDate.getSeconds() < 10 ? '0' : '') + utcDate.getSeconds();

  //   // let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //   let formattedDate: any = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //   if (format == 'date') {
  //     formattedDate = `${year}-${month}-${day}`;
  //   }

  //   // If the format is 'milliseconds', return the timestamp
  //   if (format === 'milliseconds') {
  //     formattedDate = utcDate.getTime(); // Returns Unix timestamp in milliseconds
  //   }

  //   return formattedDate;
  // }
  convertUTCToUserLocalTime(date: any, format: string = ''): any {
    // 1. Guard clause: Handle null, undefined, or 'N/A'
    if (!date || date === 'N/A' || date === '') {
      return 'N/A';
    }

    // 2. Parse as UTC and convert to user's local timezone
    // If the incoming string doesn't have 'Z' or offset, treat it explicitly as UTC
    const m = moment.utc(date).local();

    // 3. If date is invalid, return original or 'N/A'
    if (!m.isValid()) {
      return date;
    }

    // 4. Backward compatibility: 'milliseconds'
    if (format === 'milliseconds') {
      return m.valueOf(); // Returns timestamp in ms
    }

    // 5. Backward compatibility: 'date'
    if (format === 'date') {
      return m.format('YYYY-MM-DD');
    }

    // 6. Support for standard moment formats (e.g., 'yyyy-MM-dd HH:mm:ss' or 'DD/MM/YYYY')
    if (format && format !== '') {
      // Normalise lowercase yyyy/dd to Moment's YYYY/DD format
      const momentFormat = format
        .replace(/yyyy/g, 'YYYY')
        .replace(/yy/g, 'YY')
        .replace(/dd/g, 'DD');
      return m.format(momentFormat);
    }

    // 7. Default format if no format is provided
    return m.format('YYYY-MM-DD HH:mm:ss');
  }

  /* this function only convert the time (00:00:00 & 24:59:59) in to user local time zone */
  convertTimeToLocal(startTime: string, endTime: string): { localStart: string, localEnd: string } {

    function reverseConvert(time: string): string {
      const utc = moment("1970-01-01 " + time, "YYYY-MM-DD HH:mm:ss");

      // subtract local timezone offset instead of adding
      const local = utc.subtract(moment().utcOffset(), "minutes");

      return local.format("HH:mm:ss");
    }

    const localStart = reverseConvert('00:00:00');
    const localEnd = reverseConvert('23:59:59');
    // console.log('localStart', localStart);
    // console.log('localEnd', localEnd);

    return { localStart, localEnd };
  }




  convertLocalToUTC(
    dateInput: any,
    format: string = '',
    form: any = ''
  ): string {
    // Ensure dateInput is a Date object
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    // Convert the local date to UTC
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

    // Format the date as YYYY-MM-DD HH:mm:ss
    const year = utcDate.getUTCFullYear();
    const month =
      (utcDate.getUTCMonth() + 1 < 10 ? '0' : '') + (utcDate.getUTCMonth() + 1);
    const day = (utcDate.getUTCDate() < 10 ? '0' : '') + utcDate.getUTCDate();
    const hours =
      (utcDate.getUTCHours() < 10 ? '0' : '') + utcDate.getUTCHours();
    const minutes =
      (utcDate.getUTCMinutes() < 10 ? '0' : '') + utcDate.getUTCMinutes();
    const seconds =
      (utcDate.getUTCSeconds() < 10 ? '0' : '') + utcDate.getUTCSeconds();

    let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    if (format === 'date') {
      if (form === 'IND' || form === 'IND-Time') {
        formattedDate =
          form === 'IND'
            ? `${day}-${month}-${year}`
            : `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } else {
        formattedDate = `${year}-${month}-${day}`;
      }
    }

    return formattedDate;
  }

  formatDateTimeInUTC(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // setUTCDateTimeInPayload(payload: Filter, timePicker: boolean = false) {
  //   let sd;
  //   let ed;
  //   if (payload.DateTime.startDate.$d && payload.DateTime.endDate.$d) {
  //     sd = this.convertUserLocalTimeToUTC(payload.DateTime.startDate.$d);
  //     ed = this.convertUserLocalTimeToUTC(payload.DateTime.endDate.$d);
  //   } else {
  //     sd = payload.DateTime.startDate._d;
  //     // ed = moment().toString(); //current datetime to utc
  //     ed = payload.DateTime.endDate._d;
  //   }

  //   payload.startDateTime = this.convertUserLocalTimeToUTC(sd);
  //   payload.endDateTime = this.convertUserLocalTimeToUTC(ed);

  //   return payload;
  // }

  // convertUserLocalTimeToUTC(userLocalDate: any, format: string = ''): string {
  //   // Get the dynamic time zone code of the user's browser
  //   const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   // Convert user's local date to UTC
  //   const utcDate = moment(userLocalDate).utc();

  //   // Format the UTC date as YYYY-MM-DD HH:mm:ss
  //   const year = utcDate.year();
  //   const month = (utcDate.month() + 1 < 10 ? '0' : '') + (utcDate.month() + 1);
  //   const day = (utcDate.date() < 10 ? '0' : '') + utcDate.date();
  //   const hours = (utcDate.hours() < 10 ? '0' : '') + utcDate.hours();
  //   const minutes = (utcDate.minutes() < 10 ? '0' : '') + utcDate.minutes();
  //   const seconds = (utcDate.seconds() < 10 ? '0' : '') + utcDate.seconds();

  //   let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //   if ('date' == format) {
  //     formattedDate = `${year}-${month}-${day}`;
  //   }

  //   return formattedDate;
  // }

  setUTCDateTimeInPayload(payload: Filter, timePicker: boolean = false) {
    let sd;
    let ed;

    if (payload.DateTime.startDate && payload.DateTime.endDate) {
      if (payload.DateTime.startDate.$d && payload.DateTime.endDate.$d) {
        sd = this.convertUserLocalTimeToUTC(payload.DateTime.startDate.$d);
        ed = this.convertUserLocalTimeToUTC(payload.DateTime.endDate.$d);
      } else {
        sd = this.convertUserLocalTimeToUTC(payload.DateTime.startDate);
        ed = this.convertUserLocalTimeToUTC(payload.DateTime.endDate);
      }
    }

    payload.startDateTime = sd;
    payload.endDateTime = ed;

    return payload;
  }

  convertUserLocalTimeToUTC(
    userLocalDate: any,
    format: string = 'datetime'
  ): string {
    // Convert user's local date to UTC
    const utcDate = moment(userLocalDate).utc();

    // Format the UTC date as YYYY-MM-DD HH:mm:ss
    const year = utcDate.year();
    const month = (utcDate.month() + 1 < 10 ? '0' : '') + (utcDate.month() + 1);
    const day = (utcDate.date() < 10 ? '0' : '') + utcDate.date();
    const hours = (utcDate.hours() < 10 ? '0' : '') + utcDate.hours();
    const minutes = (utcDate.minutes() < 10 ? '0' : '') + utcDate.minutes();
    const seconds = (utcDate.seconds() < 10 ? '0' : '') + utcDate.seconds();

    if (format === 'date') {
      return `${year}-${month}-${day}`;
    }

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  checkPermission(permissionName: string, routeName: string): boolean {
    routeName = routeName.replace('/', '');
    const sideBar: any = localStorage.getItem('Auth-user');
    const sidebarItems = JSON.parse(sideBar).side_menu;
    for (let sideItem of sidebarItems) {
      if (
        routeName &&
        (sideItem.controller === routeName ||
          sideItem.SubMenu.some(
            (subItem: any) => subItem.controller === routeName
          ))
      ) {
        const permissions =
          sideItem.controller === routeName
            ? sideItem.permission
            : sideItem.SubMenu.find(
              (subItem: any) => subItem.controller === routeName
            ).permission;
        if (permissions.includes(permissionName)) {
          return true;
        }
      }
    }
    return false;
  }

  getPublicKey() {
    return 'd2ViLWpibmZkc0BNb2JhMjAyNQ==';
  }

  closeDropdown(): void {
    const dropdownPanel = document.querySelector(
      '.p-dropdown-panel'
    ) as HTMLElement;
    const multidropdownPanel = document.querySelector(
      '.p-multiselect-panel'
    ) as HTMLElement;
    if (dropdownPanel) {
      dropdownPanel.style.display = 'none'; // Hide the dropdown panel
    }
    if (multidropdownPanel) {
      multidropdownPanel.style.display = 'none'; // Hide the dropdown panel
    }
  }

  // numberWithCommas(value: any, module: any = ''): string {
  //   if (value === null || value === undefined) {
  //     return '';
  //   }
  //   if (value === 'Not Available') {
  //     return 'Not Avaliable';
  //   }
  //   // ✅ Remove commas and extra spaces from the value before processing
  //   value = value.toString().replace(/,/g, '').trim();

  //   var part = value.toString().split(' ');
  //   var part1 = value.toString().split('/');
  //   var formattedNumber = '';
  //   if (module == 'key-indicators') {
  //     formattedNumber =
  //       Number(part[0]).toLocaleString('en-US') +
  //       ' ' +
  //       part[1] +
  //       ' ' +
  //       part[2] +
  //       ' ' +
  //       Number(part[3]).toLocaleString('en-US') +
  //       ' ' +
  //       part[4];
  //   } else if (module == 'txn') {
  //     formattedNumber =
  //       Number(part1[0]).toLocaleString('en-US') +
  //       '/' +
  //       Number(part1[1]).toLocaleString('en-US');
  //   } else if (part[0] && part[1]) {
  //     formattedNumber = Number(part[0]).toLocaleString('en-US') + ' ' + part[1];
  //   } else {
  //     formattedNumber = Number(part[0]).toLocaleString('en-US');
  //   }
  //   return formattedNumber;
  // }

  numberWithCommas(value: any, module: any = ''): string {
    if (value === null || value === undefined) return '';
    if (value === 'Not Available') return 'Not Available';

    value = value.toString().replace(/,/g, '').trim();

    const format = (num: any) =>
      Number(num).toLocaleString('en-US').replace(/\s/g, '');

    let part = value.split(' ');
    let part1 = value.split('/');

    let formattedNumber = '';

    if (module === 'key-indicators') {
      formattedNumber =
        format(part[0]) +
        ' ' +
        (part[1] ?? '') +
        ' ' +
        (part[2] ?? '') +
        ' ' +
        format(part[3] ?? '') +
        ' ' +
        (part[4] ?? '');
    } else if (module === 'txn') {
      formattedNumber = format(part1[0]) + '/' + format(part1[1]);
    } else if (part[0] && part[1]) {
      formattedNumber = format(part[0]) + ' ' + part[1];
    } else {
      formattedNumber = format(part[0]);
    }

    return formattedNumber.trim();
  }
  numberWithCommas1(x: number) {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  // sortingSelectedVal(options: any[], selectedValues: number[]) {
  //   return options
  //     .map((option) => {
  //       if (!option.id) {
  //         // Check if id is missing
  //         return { ...option, id: option.fleetId }; // Assign fleetId to id
  //       }
  //       return option;
  //     })
  //     .sort((a, b) => {
  //       const aIndex = selectedValues.indexOf(a.id);
  //       const bIndex = selectedValues.indexOf(b.id);

  //       if (aIndex === -1 && bIndex === -1) {
  //         return a.id - b.id;
  //       }

  //       if (aIndex === -1) {
  //         return 1;
  //       }

  //       if (bIndex === -1) {
  //         return -1;
  //       }

  //       return aIndex - bIndex;
  //     });
  // }
  ////////////////below function for selected value sorting and if space come than it will remove it ////////////
  sortingSelectedVal(options: any[], selectedValues: number[]) {
    return options
      .map((option) => {
        const cleanedOption: any = Object.fromEntries(
          Object.entries(option).map(([key, value]) => {
            if (typeof value === 'string') {
              return [key, value.replace(/\s+/g, ' ').trim()];
            }
            return [key, value];
          })
        );

        if (!cleanedOption.id) {
          cleanedOption.id = cleanedOption.fleetId;
        }

        return cleanedOption;
      })
      .sort((a, b) => {
        if (!selectedValues || selectedValues.length === 0) {
          const getFirstStringField = (obj: any) => {
            for (const key in obj) {
              if (typeof obj[key] === 'string') {
                return obj[key];
              }
            }
            return '';
          };
          return getFirstStringField(a).localeCompare(
            getFirstStringField(b),
            undefined,
            { sensitivity: 'base' }
          );
        }

        const aIndex = selectedValues.indexOf(a.id);
        const bIndex = selectedValues.indexOf(b.id);

        if (aIndex === -1 && bIndex === -1) {
          const getFirstStringField = (obj: any) => {
            for (const key in obj) {
              if (typeof obj[key] === 'string') {
                return obj[key];
              }
            }
            return '';
          };
          return getFirstStringField(a).localeCompare(
            getFirstStringField(b),
            undefined,
            { sensitivity: 'base' }
          );
        }

        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;

        return aIndex - bIndex;
      });
  }

  ////Below function for user whole object sorting
  // sortingForWholeObjectVal(options: any[], selectedValues: any[]) {
  //   const selectedIds = selectedValues.map((val) =>
  //     typeof val === 'object' && val !== null ? val.id : val
  //   );

  //   return options.slice().sort((a, b) => {
  //     const aIndex = selectedIds.indexOf(a.id);
  //     const bIndex = selectedIds.indexOf(b.id);

  //     if (aIndex === -1 && bIndex === -1) {
  //       return a.id - b.id;
  //     }

  //     if (aIndex === -1) {
  //       return 1;
  //     }

  //     if (bIndex === -1) {
  //       return -1;
  //     }

  //     return aIndex - bIndex;
  //   });
  // }
  //////////////////Below function for user whole object sorting and if space come than it will remove it ////////////
  sortingForWholeObjectVal(options: any[] = [], selectedValues: any[] = []) {
    const selectedIds = (selectedValues || []).map((val) =>
      typeof val === 'object' && val !== null ? val.id : val
    );

    const cleanObject = (obj: any): any => {
      if (!obj || typeof obj !== 'object') return obj;

      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          if (typeof value === 'string') {
            return [key, value.replace(/\s+/g, ' ').trim()];
          }
          if (typeof value === 'object' && value !== null) {
            return [key, cleanObject(value)];
          }
          return [key, value];
        })
      );
    };

    return (options || [])
      .map((option) => cleanObject(option))
      .sort((a, b) => {
        const aIndex = selectedIds.indexOf(a?.id);
        const bIndex = selectedIds.indexOf(b?.id);

        if (aIndex === -1 && bIndex === -1) {
          return (a?.value?.siteCode ?? a?.id ?? '')
            .toString()
            .toLowerCase()
            .localeCompare(
              (b?.value?.siteCode ?? b?.id ?? '').toString().toLowerCase()
            );
        }

        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;

        return aIndex - bIndex;
      });
  }

  downloadBase64File(file: any, fileName: string) {
    const base64String = file; // Your base64 string here
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' }); // Change type based on file format

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}`; // Change filename & extension as needed
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  // toggleColumnFreeze(cols: any[], col: any): any[] {
  //   col.isColumnFrozen = !col.isColumnFrozen;

  //   if (col.isColumnFrozen) {
  //     return [
  //       ...cols.filter((c) => c.isColumnFrozen),
  //       ...cols.filter((c) => !c.isColumnFrozen),
  //     ];
  //   } else {
  //     const originalIndex = col.originalIndex;
  //     const unfrozenCol = { ...col };
  //     const remainingCols = cols.filter((c) => c.field !== col.field);

  //     if (originalIndex !== undefined) {
  //       remainingCols.splice(originalIndex, 0, unfrozenCol);
  //     } else {
  //       remainingCols.push(unfrozenCol);
  //     }

  //     return [...remainingCols];
  //   }
  // }

  toggleColumnFreeze(cols: any[], col: any): any[] {
    col.isColumnFrozen = !col.isColumnFrozen;

    // Clone the columns for safe mutation
    const updatedCols = [...cols];

    // Find the action column
    const actionCol = updatedCols.find((c) => c.field === 'action');

    // If we're freezing this column
    if (col.isColumnFrozen) {
      // Freeze the action column if it's not already frozen
      if (actionCol && !actionCol.isColumnFrozen) {
        actionCol.isColumnFrozen = true;
      }

      // Put all frozen columns (including action) first
      return [
        ...updatedCols.filter((c) => c.isColumnFrozen),
        ...updatedCols.filter((c) => !c.isColumnFrozen),
      ];
    }

    // If we're unfreezing this column
    const unfrozenCol = { ...col, isColumnFrozen: false };
    const remainingCols = updatedCols.filter((c) => c.field !== col.field);

    // Determine if this is the last frozen column (excluding 'action')
    const frozenWithoutAction = remainingCols.filter(
      (c) => c.isColumnFrozen && c.field !== 'action'
    );

    // If no other frozen columns left, unfreeze 'action'
    if (
      frozenWithoutAction.length === 0 &&
      actionCol &&
      actionCol.isColumnFrozen
    ) {
      actionCol.isColumnFrozen = false;

      // Remove and re-insert action column at original index
      const actionIndex = actionCol.originalIndex ?? cols.length - 1;
      const withoutAction = remainingCols.filter((c) => c.field !== 'action');
      withoutAction.splice(actionIndex, 0, actionCol);

      // Also insert this unfrozen col back at original index
      if (col.originalIndex !== undefined) {
        withoutAction.splice(col.originalIndex, 0, unfrozenCol);
      } else {
        withoutAction.push(unfrozenCol);
      }

      return [...withoutAction];
    }

    // Just unfreeze this column and place it at its original index
    if (col.originalIndex !== undefined) {
      remainingCols.splice(col.originalIndex, 0, unfrozenCol);
    } else {
      remainingCols.push(unfrozenCol);
    }

    return [...remainingCols];
  }

  /**
   * Debounced column search for PrimeNG Table.
   */
  static debouncedColumnSearch(context: any, value: string, field: string) {
    const zeroLengthFields = [
      'ALD_ALD_NOZZLE',
      'distance',
      'FLTM_FLT_TARGET_VALUE',
    ];
    const isZeroLengthFields = zeroLengthFields.includes(field);
    if (context.searchTimeout) {
      clearTimeout(context.searchTimeout);
      context.searchTimeout = null;
    }
    context.searchTimeout = setTimeout(() => {
      if (context.dt1 && typeof context.dt1.filter === 'function') {
        try {
          if (
            (isZeroLengthFields && value.length >= 1) ||
            value.length > 2 ||
            value.length === 0
          ) {
            context.dt1.filter(value, field, 'contains');
          }
        } catch (err) {
          console.error('Column filter failed:', err);
        }
      }
      context.searchTimeout = null;
    }, 700);
  }

  static debouncedGlobalSearch(context: any, value: string[]) {
    if (context.globalFilterTimeout) {
      clearTimeout(context.globalFilterTimeout);
      context.globalFilterTimeout = null;
    }
    if (!context.dt1) return;
    context.globalFilterTimeout = setTimeout(() => {
      if (context.dt1 && typeof context.dt1.filterGlobal === 'function') {
        try {
          if (
            value.every((term) => term.trim() === '') ||
            value.some((term) => term.trim().length > 0)
          ) {
            context.dt1.filterGlobal(value, 'contains');
          }
        } catch (err) {
          console.error('Global filter failed:', err);
        }
      }
      context.globalFilterTimeout = null;
    }, 700);
  }
  //  search dropdown value in table
  static isFilterMetadataArray(
    filters: FilterMetadata | FilterMetadata[]
  ): filters is FilterMetadata[] {
    return Array.isArray(filters);
  }

  // static getDropdownOptions(
  //   dt1: any,
  //   listArr: any[],
  //   field: string,
  //   fieldHandlers: { [key: string]: any[] }
  // ): any[] {
  //   const filterValue = dt1?.filters[field];
  //   let dropdownValue: any;

  //   if (filterValue) {
  //     if (this.isFilterMetadataArray(filterValue)) {
  //       dropdownValue = filterValue[0]?.value;
  //     } else {
  //       dropdownValue = filterValue.value;
  //     }
  //   }

  //   fieldHandlers[field] = listArr.map((item) => item[field]);
  //   return [...new Set(fieldHandlers[field])];
  // }
  // static filterData(
  //   dt1: any,
  //   dropdownValues: any,
  //   event: any,
  //   field: string
  // ) {
  //   const selectedValue = event.value;
  //   dropdownValues[field] = selectedValue;

  //   if (dt1) {
  //     if (selectedValue === null) {
  //       dt1.filter('', field, 'contains');
  //     } else {
  //       dt1.filter(selectedValue, field, 'contains');
  //     }
  //   }
  // }

  static filterData(
    dt1: any,
    dropdownValues: any,
    event: any,
    field: string,
    isSeverSide: boolean = true,
    callback?: () => void
  ) {
    const selectedValue = event.value;
    // Store selected values
    dropdownValues[field] = selectedValue;
    const commaSensitiveFields = [
      'PRL_PRL_DIESEL_PRICE',
      'PRL_PRL_HANDLING_PRICE',
      'DFD_DFD_FUE_SALE_LTR',
      'TNK_TNK_CAPACITY',
      'DC_DEC_SALE_LTR',
      'DC_DEC_TOTALIZER',
      'DC_DEC_TANKER_NUMBER',
      'DC_DEC_COMPARTMENT_NUMBER',
      'DC_DEC_CALIBRATION_RATE',
    ];
    // Clean only if field matches and it's server-side
    let cleanedSelectedValue =
      isSeverSide && commaSensitiveFields.includes(field)
        ? Array.isArray(selectedValue)
          ? selectedValue.map((val) =>
            typeof val === 'string' ? val.replace(/,/g, '') : val
          )
          : typeof selectedValue === 'string'
            ? selectedValue.replace(/,/g, '')
            : selectedValue
        : selectedValue;

    if (field === 'USM_USM_MOBILENO' && Array.isArray(cleanedSelectedValue)) {
      cleanedSelectedValue = cleanedSelectedValue.map((val) =>
        btoa(String(val))
      );
    }
    /////////////////////////////
    const fieldValueMap: { [key: string]: { [key: string]: number } } = {
      FLT_FLT_ISACTIVE: {
        Active: 1,
        Inactive: 0,
      },
      FLT_FLT_ISGPS2: {
        Yes: 1,
        No: 0,
      },
      SAP_TRANSACTION_LOG: {
        Yes: 1,
        No: 0,
      },
      EMP_EMP_ISACTIVE: {
        Yes: 1,
        No: 0,
      },
      USM_USM_ISACTIVE: {
        Active: 1,
        Inactive: 0,
      },
      deviceStatus: {
        Onboarded: 1,
        Deboarded: 0,
      },
      tagStatus: {
        Assigned: 1,
        Unassigned: 0,
      },
      status: {
        Assigned: 1,
        Unassigned: 0,
      },
      isActive: {
        Active: 1,
        Inactive: 0,
      },
      PRL_PRL_SAP_SYNC: {
        Booked: 1,
        Pending: 0,
      },
      FFC_FFC_ISACTIVE: {
        Active: 1,
        Inactive: 0,
      },
    };
    if (fieldValueMap[field]) {
      if (Array.isArray(cleanedSelectedValue)) {
        cleanedSelectedValue = cleanedSelectedValue.map(
          (val) => fieldValueMap[field][val] ?? val
        );
      } else {
        cleanedSelectedValue =
          fieldValueMap[field][cleanedSelectedValue] ?? cleanedSelectedValue;
      }
    }

    // Final filter input
    const valueToFilter = Array.isArray(cleanedSelectedValue)
      ? cleanedSelectedValue.map((val) => String(val))
      : [String(cleanedSelectedValue)];

    // Convert to string array (without JSON.stringify)
    // OLD LOGIC
    // const valueToFilter = Array.isArray(selectedValue)
    //   ? selectedValue.map((val) => String(val))
    //   : [String(selectedValue)];
    if (!isSeverSide) {
      const valueToFilter = Array.isArray(selectedValue)
        ? selectedValue.map((val) =>
          typeof val === 'number' ? val : String(val)
        )
        : [String(selectedValue)];

      if (dt1) {
        // Use "in" for multiple value matching
        dt1.filter(valueToFilter, field, 'in');
      }
      if (callback && !isSeverSide) {
        setTimeout(() => {
          callback();
        }, 0);
      }
    } else {
      if (dt1) {
        const specialFields = ['FLT_FLT_ISACTIVE', 'FLT_FLT_ISGPS2'];
        const matchMode = specialFields.includes(field) ? 'equals' : 'contains';
        dt1.filter(valueToFilter, field, matchMode);
      }
    }
  }

  static getDropdownOptions(
    dt1: any,
    listArr: any[],
    field: string,
    fieldHandlers: { [key: string]: any[] }
  ): any[] {
    const filterValue = dt1?.filters?.[field];
    let dropdownValue: any;

    if (filterValue) {
      if (this.isFilterMetadataArray(filterValue)) {
        dropdownValue = filterValue[0]?.value;
      } else {
        dropdownValue = filterValue.value;
      }
    }

    const fieldValueMap: { [key: string]: { [key: number]: string } } = {
      FLT_FLT_ISACTIVE: {
        1: 'Active',
        0: 'Inactive',
      },
      FLT_FLT_ISGPS2: {
        1: 'Yes',
        0: 'No',
      },
      SAP_TRANSACTION_LOG: {
        1: 'Yes',
        0: 'No',
      }
    };

    const values = listArr
      .map((item) => {
        let val = item[field];

        // If mapping exists for this field, use it
        if (fieldValueMap[field] && (val === 1 || val === 0)) {
          return fieldValueMap[field][val];
        }

        return val;
      })
      .filter((val) => val !== null && val !== undefined && val !== '');
    // Extract and filter values
    // const values = listArr
    //   .map((item) => item[field])
    //   .filter((val) => val !== null && val !== undefined && val !== '');

    // Sort in ascending order
    const sortedValues = [...new Set(values)].sort((a, b) =>
      a.toString().toLowerCase().localeCompare(b.toString().toLowerCase())
    );

    // Assign sorted values to fieldHandlers
    fieldHandlers[field] = sortedValues;

    // Return unique options as { label, value } objects
    return [...new Set(sortedValues)].map((val) => ({
      label: val,
      value: val,
    }));
  }

  // Table ToolTip show
  getTooltip(
    content: string,
    element: HTMLElement,
    threshold = 100
  ): string | undefined {
    if (element && element.offsetWidth < threshold) {
      return content;
    } else {
      return undefined;
    }
  }

  handleColResize(
    event: any,
    width: number | undefined,
    columnTooltips: { [key: string]: string | undefined }
  ): void {
    let colField: string | null = '';
    let colWidth: number | undefined = undefined;

    if (event && typeof event === 'object' && event.element) {
      const colElement = event.element as HTMLElement;
      colWidth = colElement.offsetWidth;
      colField = colElement.getAttribute('data-field');
    } else if (typeof event === 'string') {
      colWidth = width;
      colField = event;
    }

    if (!colField) {
      console.warn('Field not found for resized column');
      return;
    }

    const threshold =
      colField === 'costAccountName' ||
        colField === 'EMP_EMP_ORGUNITNAME' ||
        colField === 'FLTM_FLT_DESCRIPTION'
        ? 230
        : colField === 'comment' || colField === 'FLT_FLT_DESCRIPTION'
          ? 300
          : 120;

    if (colWidth !== undefined && colWidth < threshold) {
      columnTooltips[colField] = 'SHOW_TOOLTIP';
    } else {
      columnTooltips[colField] = undefined;
    }
  }

  /*
   * @category WEBSITE
   * @author Original Author <vsharaf@moba.de>
   * @copyright MOBA
   * @comment Handles keyboard navigation for multiselect dropdowns.
   * @date 2025-06-26
   */
  handleKeyboard(event: KeyboardEvent) {
    const key = event.key;

    if (['ArrowDown', 'ArrowUp', 'Enter'].includes(key)) {
      event.preventDefault();

      const panel = document.querySelector('.p-multiselect-panel');
      const items = panel?.querySelectorAll(
        '.p-multiselect-items .p-multiselect-item'
      );

      if (!items || items.length === 0) return;

      const focused = panel?.querySelector('.p-multiselect-item.p-highlight');

      let index = Array.from(items).indexOf(focused as HTMLElement);
      if (key === 'ArrowDown') {
        index = (index + 1) % items.length;
      } else if (key === 'ArrowUp') {
        index = (index - 1 + items.length) % items.length;
      } else if (key === 'Enter' && focused) {
        (focused as HTMLElement).click();
        return;
      }

      items.forEach((el) => el.classList.remove('p-highlight'));
      (items[index] as HTMLElement).classList.add('p-highlight');
      (items[index] as HTMLElement).scrollIntoView({ block: 'nearest' });
    }
  }
  /////
  // Remove search focus////////////
  onSearchKeyDown(event: KeyboardEvent, dropdown: any): void {
    const key = event.key;

    if (key === 'ArrowDown') {
      event.preventDefault();
      dropdown.focus();
      setTimeout(() => {
        const items = dropdown.items?.toArray();
        if (items?.length) {
          items[0].nativeElement.focus();
        }
      });
    }

    if (key === 'Enter') {
      event.preventDefault();
      if (dropdown.visibleOptions?.length) {
        dropdown.selectItem(event, dropdown.visibleOptions[0]);
      }
    }
  }

  // dtScrollFunction(id = '') {
  //   let dataTableScrollHead = document.querySelector('.custom-horizontal-scroll');
  //   if (id) {
  //     dataTableScrollHead = document.querySelector(
  //       '#' + id + ' .custom-horizontal-scroll'
  //     );
  //   }
  //   if (dataTableScrollHead) {
  //     // $('.custom-horizontal-scroll').css({
  //     //   'overflow-x': 'scroll',
  //     // });
  //     dataTableScrollHead.addEventListener('scroll', (event: any) => {
  //       let scrollBody = event.target.parentElement.parentElement;
  //       scrollBody.scrollLeft = event.target.scrollLeft;
  //       $(scrollBody).trigger('scroll');
  //     });
  //   }
  // }
  dtScrollFunction(id = '') {
    const dataTableScrollHead = document.querySelector(
      '.custom-horizontal-scroll'
    );

    if (dataTableScrollHead) {
      dataTableScrollHead.addEventListener('scroll', (event: any) => {
        const scrollHead = event.target as HTMLElement;
        const parent = scrollHead.parentElement;

        if (parent) {
          // const scrollBody = event.target.parentElement.nextElementSibling; // adjust if needed
          const scrollBody =
            event.target.parentElement.parentElement.parentElement; // adjust if needed

          if (scrollBody) {
            (scrollBody as HTMLElement).scrollLeft = scrollHead.scrollLeft;
            scrollBody.dispatchEvent(new Event('scroll')); // ✅ No jQuery
          } else {
            console.warn('Scroll body not found');
          }
        }
      });
    }
  }

  /*
   * @category WEBSITE
   * @author Original Author <dbhavsar@moba.de>
   * @copyright MOBA
   * @comment Handles dynamic cloumn Width for table.
   * @date 2025-08-05
   */

  handleColumnResize(
    event: any,
    cols: any[],
    recordToUse: any[],
    passColumnWidth: (columnId: any, width: number) => void,
    columnTooltips: { [key: string]: string | undefined }
  ): any[] {
    const fieldName = event?.element?.dataset?.field;
    const delta = event?.delta;

    if (!fieldName || delta === undefined || delta === null) {
      console.warn('Missing field or delta in column resize event');
      return cols;
    }

    const minWidth = 150;

    const updatedCols = cols.map((col) => {
      if (col.field === fieldName) {
        const currentWidth = col.width || 150;
        let newWidth = currentWidth + delta;

        if (newWidth < minWidth) {
          newWidth = minWidth;
        }

        newWidth = parseInt(newWidth.toString(), 10);

        // Pass updated width to callback
        const matchedColumn = recordToUse.find(
          (c) => c.fieldName === fieldName
        );
        if (matchedColumn) {
          passColumnWidth(matchedColumn.columnId, newWidth);
        }

        // Tooltip logic
        const threshold =
          fieldName === 'costAccountName' ||
            fieldName === 'EMP_EMP_ORGUNITNAME' ||
            fieldName === 'FLTM_FLT_DESCRIPTION'
            ? 230
            : fieldName === 'comment' || fieldName === 'FLT_FLT_DESCRIPTION'
              ? 300
              : fieldName === 'fleetCode'
                ? 100
                : 120;

        if (newWidth < threshold) {
          columnTooltips[fieldName] = 'SHOW_TOOLTIP';
        } else {
          columnTooltips[fieldName] = undefined;
        }

        return { ...col, width: newWidth, isResized: true };
      }
      return col;
    });

    return updatedCols;
  }


  /* For filtring the recordes of all server side false table based on
  the selected Filter value.*/
  filterList(listArr: any[], filterValues: any) {
    delete filterValues?.value;

    return listArr.filter((item) => {
      // Check every field in filterValues
      return Object.keys(filterValues).every((field) => {
        const selectedValues = filterValues[field];

        // If no values selected for this field → ignore (always true)
        if (!selectedValues || selectedValues.length === 0) {
          return true;
        }

        // Actual value from the record
        const recordValue = item[field];

        // Normalize to string for comparison
        const recordStr = recordValue !== undefined && recordValue !== null
          ? recordValue.toString().toLowerCase()
          : "";

        // Check if the record value matches ANY selected value
        return selectedValues
          .map((v: any) => v.toString().toLowerCase())
          .includes(recordStr);
      });
    });
  }

  /**
   * Checks if the given ElementRef array contains any truncated elements.
   * If a truncated element is found, it will be stored in the given Map.
   * The key of the map will be the HTMLElement and the value will be a boolean indicating whether or not the element is truncated.
   * @param cellContents The array of ElementRef to check for truncation
   * @param truncatedMap The Map where the truncated elements will be stored
   */
  checkTruncations(
    cellContents: ElementRef[],
    truncatedMap: Map<HTMLElement, boolean>
  ): void {
    if (!cellContents || cellContents.length === 0) {
      return;
    }

    cellContents.forEach((elRef: ElementRef) => {
      const el = elRef.nativeElement as HTMLElement;
      if (!el) return;

      const isTrunc = el.scrollWidth > el.clientWidth;
      truncatedMap.set(el, isTrunc);
    });
  }

  /**
   * Quick helper for single element truncation check on demand.
   */
  isTruncated(el: HTMLElement): boolean {
    return !!el && el.scrollWidth > el.clientWidth;
  }
  static handleVirtualScrollToggle(
    event: any,
    field: string,
    getOptions: (field: string) => any[],
    virtualScrollMap: Record<string, boolean>,
    threshold: number = 20
  ): void {
    const filterText = (event?.filter || '').toString().toLowerCase();

    const allOptions = getOptions(field) || [];

    const filtered = filterText
      ? allOptions.filter(opt =>
        opt.label?.toString().toLowerCase().includes(filterText)
      )
      : allOptions;

    virtualScrollMap[field] =
      filtered.length === 1 ? false : allOptions.length >= threshold;
  }

  public static calculateScrollHeight(offset: number = 250, rowHeight: number = 40) {
    const available = window.innerHeight - offset;
    const calculatedHeight = Math.max(300, available); // Minimum 300px

    // The +5 adds a buffer to prevent empty spaces at the bottom
    const rowCount = Math.floor(calculatedHeight / rowHeight) + 5;

    return {
      height: `${calculatedHeight}px`,
      rows: Array(rowCount).fill(0)
    };
  }

  realignDropdownOverlay(dropdown: any): void {
    setTimeout(() => {
      if (dropdown?.overlayVisible) {
        dropdown.overlayViewChild?.alignOverlay?.();
      }
    }, 0);
  }
  isOverflowing(el: HTMLElement): boolean {
    return el.scrollWidth > el.offsetWidth;
  }

  /**
   * Highlights matching search text within a string by wrapping it in a span.
   * Supports numeric matching that ignores commas (e.g., "50041" matches "50,041")
   * @param value - The value to search within
   * @param searchText - The text to highlight
   * @returns HTML string with highlighted matches
   */
  static highlightText(value: any, searchText: string): string {
    if (value === null || value === undefined) return '';

    const text = String(value);

    if (!searchText || !searchText.trim()) return text;

    const trimmedSearch = searchText.trim();
    const escapedSearch = Globals.escapeRegExp(trimmedSearch);

    // 1️⃣ Try direct match first (case-insensitive)
    const directRegex = new RegExp(`(${escapedSearch})`, 'gi');
    if (directRegex.test(text)) {
      return text.replace(
        new RegExp(`(${escapedSearch})`, 'gi'),
        '<span class="search-highlight">$1</span>'
      );
    }

    // 2️⃣ Numeric match: if search is purely digits (or digits with dot)
    //    and text contains commas → strip commas, find match, re-map indices
    const isNumericSearch = /^[\d.]+$/.test(trimmedSearch);
    const textHasCommas = text.includes(',');

    if (isNumericSearch && textHasCommas) {
      const textNoCommas = text.replace(/,/g, '');
      const numericRegex = new RegExp(escapedSearch, 'i');
      const match = textNoCommas.match(numericRegex);

      if (match) {
        const matchStr = match[0];
        const startIdx = textNoCommas.toLowerCase().indexOf(matchStr.toLowerCase());
        const endIdx = startIdx + matchStr.length;

        // Map indices back to original text (with commas)
        let originalStart = -1;
        let originalEnd = -1;
        let cleanIdx = 0;

        for (let i = 0; i < text.length; i++) {
          if (text[i] === ',') continue;
          if (cleanIdx === startIdx && originalStart === -1) {
            originalStart = i;
          }
          if (cleanIdx === endIdx - 1) {
            originalEnd = i + 1;
            break;
          }
          cleanIdx++;
        }

        if (originalStart !== -1 && originalEnd !== -1) {
          return (
            text.substring(0, originalStart) +
            '<span class="search-highlight">' +
            text.substring(originalStart, originalEnd) +
            '</span>' +
            text.substring(originalEnd)
          );
        }
      }
    }

    return text;
  }

  /**
   * Escapes special regex characters in a string.
   * @param text - The text to escape
   * @returns Escaped string safe for use in RegExp
   */
  static escapeRegExp(text: string): string {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
